import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import ContactMap from './components/ContactMap';
import { useTitle } from '@/hooks/useTitle';
import { SchemaOrg } from '@/components/base/SchemaOrg';

import PageCta from '@/components/feature/PageCta';

const siteUrl = import.meta.env.VITE_SITE_URL;

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  'name': '聯絡我們｜保險建築師免費諮詢預約',
  'url': `${siteUrl}/contact`,
  'description': '聯繫保險建築師陳琮恩，預約免費保險諮詢或加入 LINE@ 快速提問，協助您規劃最適合的保障方案。',
  'about': {
    '@type': 'ProfessionalService',
    'name': '保險建築師',
    'url': siteUrl,
    'telephone': '+886-987-654-321',
    'email': 'info@insurancearchitect.com',
  },
};

export default function Contact() {
  useTitle({
    title: '聯絡我們｜保險建築師免費諮詢預約',
    description: '聯繫保險建築師陳琮恩，預約免費保險諮詢或加入 LINE@ 快速提問，協助您規劃最適合的保障方案。',
    canonicalPath: '/contact',
  });
  return (
    <main>
      <SchemaOrg data={schemaData} />
      <Navbar />
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <ContactMap />
      <PageCta />
      <Footer />
    </main>
  );
}